<template>
  <div class="culture">
    <div class="banner"></div>
    <div class="culturecontent">
      <div class="navs">
        <navlist :navlist="navlist" @returnpath="returnpath" />
      </div>
      <div class="miancontent">
        <cultureidea v-if="navindex == 0" @sendnewsinfo="sendnewsinfo"/>
        <cultureactive v-if="navindex == 1" @sendnewsinfo="sendnewsinfo"/>
      </div>
    </div>
  </div>
</template>

<script>
import navlist from "./commonnavs.vue";
import cultureidea from "./cultureidea.vue";
import cultureactive from "./cultureactive.vue";
export default {
  components: { navlist, cultureidea, cultureactive },
  data() {
    return {
      navlist: {
        name: "品牌文化",
        list: [
          { name: "文化理念", index: 0 },
          { name: "文化活动", index: 1 },
        ],
      },
      navindex: 0,
    };
  },
  methods: {
    returnpath(e) {
      this.navindex = e;
    },
    sendnewsinfo(e) {
      this.$router.push({
        path: "/news/info",
        query: e,
      });
    },
  },
  watch: {
    $route(to, from) {
      if (to.query.index) {
        this.navindex = to.query.index;
      }
    },
  },
};
</script>

<style scoped lang="less">
.culture {
  .culturecontent {
    .miancontent {
      flex: 1;
    }
    .navs {
      width: 10.42vw;
      height: 21.88vw;
      margin-right: 1.25vw;
    }
    width: 100%;
    padding: 2.08vw 13.54vw 5.21vw 13.54vw;
    display: flex;
  }
  .banner {
    width: 100%;
    height: 26.04vw;
    //background: url("https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/banner/bannerculturetop.png") no-repeat;
    background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/bannerculturetop.png") no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
  }
  width: 100%;
  background: rgba(240, 242, 246, 1);
}
</style>
